import { createRouter, createWebHistory } from 'vue-router'
import ChatView from '../views/ChatView.vue'
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'chat',
    component: ChatView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/about',
    name: 'about',
    // Lazy loading route
    component: () => import('../views/AboutView.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is logged in
    const sessionStr = localStorage.getItem('session')
    const session = sessionStr ? JSON.parse(sessionStr) : null
    
    if (!session || session.expiresAt < Date.now()) {
      // Not logged in or session expired
      next({ name: 'login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
